// extracted by mini-css-extract-plugin
export default {"close":"close-CLbu","back":"back-FObz"};